(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const sticky = document.querySelector("[data-sticky-atc]");
    if (!sticky) return;

    const stickyBtn = sticky.querySelector("[data-sticky-atc-button]");
    if (!stickyBtn) return;

    // Find your main product add-to-cart button (robust for styled themes)
const findMainATCButton = () => {
  // Preferred: Dawn-style main product submit button
  const preferred = document.querySelector(
    'main#MainContent form[action*="/cart/add"] button[id^="ProductSubmitButton"]'
  );
  if (preferred) return preferred;

  // Fallback: visible submit button in the main product form
  const candidates = Array.from(
    document.querySelectorAll(
      'main#MainContent form[action*="/cart/add"] button[type="submit"], main#MainContent form[action*="/cart/add"] button'
    )
  ).filter((btn) => btn.offsetParent !== null);

  return candidates.find((btn) => !btn.disabled) || candidates[0] || null;
};

    const mainATCButton = findMainATCButton();
    if (!mainATCButton) return;
// Copy classes + label from the real ATC so styling always matches your theme
stickyBtn.className = mainATCButton.className;
stickyBtn.classList.add("cs-sticky-atc__button"); // keep sticky-specific hook
stickyBtn.textContent = mainATCButton.textContent.trim() || "Add to cart";
    // Show sticky only when the main ATC button scrolls out of view
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting;
      },
      { threshold: 0.01 }
    );

const btnToObserve = findMainATCButton();
if (!btnToObserve) return;
observer.observe(btnToObserve);

    // Keep disabled state in sync (variants / sold out)
    const syncDisabled = () => {
      const btn = findMainATCButton();
      if (!btn) return;
      stickyBtn.disabled = btn.disabled;
      stickyBtn.setAttribute("aria-disabled", String(btn.disabled));
    };

    document.addEventListener("change", syncDisabled, true);
    document.addEventListener("variant:change", syncDisabled, true);
    syncDisabled();

    stickyBtn.addEventListener("click", function () {
      const btn = findMainATCButton();
      if (!btn) return;

      // If disabled, scroll to the main form (usually variant selection needed)
      if (btn.disabled) {
        btn.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      // Trigger Dawn's native add-to-cart flow
      btn.click();
    });
  });
})();